var _a;
import { createEntityAdapter } from '@reduxjs/toolkit';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { transformLayoutServiceModelResult, transformLayoutServiceTransmissionApiResult, transformLayoutServiceApiAssetsResult, transformLayoutServiceThreeSixtyResult, transformLayoutServiceRecommendVehicles, } from '../apiResponseTransformers/layoutService';
export var trimsAdapter = createEntityAdapter({
    selectId: function (trim) { return trim === null || trim === void 0 ? void 0 : trim.trimKey; },
    sortComparer: function (a, b) { var _a; return (_a = a === null || a === void 0 ? void 0 : a.trimKey) === null || _a === void 0 ? void 0 : _a.localeCompare(b === null || b === void 0 ? void 0 : b.trimKey); },
});
var layoutServiceApi = createApi({
    reducerPath: 'layoutServiceApi',
    baseQuery: fetchBaseQuery(),
    endpoints: function (builder) { return ({
        getLayoutServiceModel: builder.query({
            query: function (_a) {
                var url = _a.url, params = _a.params;
                return ({ url: url, method: 'GET', params: params });
            },
            transformResponse: transformLayoutServiceModelResult,
        }),
        getColorByTransmission: builder.query({
            query: function (_a) {
                var url = _a.url;
                return ({ url: url });
            },
            transformResponse: transformLayoutServiceTransmissionApiResult,
        }),
        getStudioAssetsById: builder.query({
            query: function (_a) {
                var url = _a.url;
                return ({ url: url });
            },
            transformResponse: transformLayoutServiceApiAssetsResult,
        }),
        get360AssetsById: builder.query({
            query: function (_a) {
                var url = _a.url, body = _a.body;
                return ({
                    url: url,
                    method: 'POST',
                    body: body,
                });
            },
            transformResponse: transformLayoutServiceThreeSixtyResult,
        }),
        getRecommendedVehicles: builder.query({
            query: function (_a) {
                var url = _a.url, body = _a.body;
                return ({
                    url: url,
                    method: 'POST',
                    body: body,
                });
            },
            transformResponse: transformLayoutServiceRecommendVehicles,
        }),
    }); },
});
// Trim entity selectors
export var allTrimsSelector = (_a = trimsAdapter.getSelectors(), _a.selectAll), trimByIdSelector = _a.selectById, trimIdsSelector = _a.selectIds;
var initialTrimState = trimsAdapter.getInitialState();
export var selectAllTrims = function (trims) { return allTrimsSelector(trims !== null && trims !== void 0 ? trims : initialTrimState); };
export var layoutServiceApiReducer = layoutServiceApi.reducer;
export var layoutServiceApiMiddleware = layoutServiceApi.middleware;
export var useGetLayoutServiceModelQuery = layoutServiceApi.useGetLayoutServiceModelQuery, useGet360AssetsByIdQuery = layoutServiceApi.useGet360AssetsByIdQuery, useGetColorByTransmissionQuery = layoutServiceApi.useGetColorByTransmissionQuery, useGetStudioAssetsByIdQuery = layoutServiceApi.useGetStudioAssetsByIdQuery, useGetRecommendedVehiclesQuery = layoutServiceApi.useGetRecommendedVehiclesQuery;
export default layoutServiceApi;
